<template>
  <div class="mb-4">
    <div>
      <button class="btn btn-info btn-icon mw" @click="getEpolisFile">
        {{ "next" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify, toFormData } from "@/plugins/functions";

export default {
  methods: {
    errorSimurg(error = -1) {
      switch (error) {
        case 0:
          return "Успешная обработка запроса";
          break;

        case -32504:
          return "Недостаточно привилегий для выполнения метода";
          break;
        case 0:
          return "Успешная обработка запроса";
          break;
        case 1:
          return "Ошибка в json формате";
          break;
        case 2:
          return "Ошибка в серии полиса";
          break;
        case 3:
          return "Ошибка в номере полиса";
          break;
        case 4:
          return "Полис не существует в базе";
          break;
        case 5:
          return "Шаблон распечатки полиса не введен";
          break;
        case 100:
          return "Системная ошибка при обработке запроса";
          break;

        default:
          return "Неизвестная ошибка";
          break;
      }
    },
    async getEpolisFile() {
      this.$loading(true);
      //INIT
      const url = `${this.currentRequest.service.api_endpoint_url}PolicyIssuanceRequest`;
      const method = "post";
      const headers = {
        Authorization:
          "Basic " +
          btoa(
            this.currentRequest.service.api_login +
              ":" +
              this.currentRequest.service.api_password
          ),
      };

      //DATA
      let data = {
        polis_sery: this.currentRequest.response.polis_sery,
        polis_number: this.currentRequest.response.polis_number,
      };

      //REQUEST
      var instance = this.$http.create();
      delete instance.defaults.headers.common["Authorization"];
      delete instance.defaults.headers.common["bid"];
      delete instance.defaults.headers.common["localization"];
      delete instance.defaults.headers.common["shop"];
      delete instance.defaults.headers.common["device"];
      delete instance.defaults.headers.common["tab"];
      delete instance.defaults.headers.common["root"];
      delete instance.defaults.headers.common["version"];
      const config = {
        method: method,
        url: url,
        data: data,
        headers: {
          // Ваши заголовки, которые нужно удалить
          common: {
            Authorization:
              "Basic " +
              btoa(
                this.currentRequest.service.api_login +
                  ":" +
                  this.currentRequest.service.api_password
              ),
          },
        },
      };

      //REQUEST
      return instance(config)
        .then((response) => {
          this.$loading(false);
          const responseData = response.data;

          if (responseData && responseData.result == 0) {
            this.$emit("input", {
              service_request: {
                state: "done",
                file: responseData.content_string,
                file_name: responseData.file_name,
                exchange_id: this.currentRequest.exchange_id,
                service: "semurg",
                response: JSON.stringify(responseData),
                body: JSON.stringify(data),
              },
            });
          }

          this.$notify({
            title: "Страховая система",
            message: this.errorSimurg(responseData.result),
            icon: "ti-info",
            horizontalAlign: "right",
            verticalAlign: "top",
          });

          logger(this.$http, {
            name: `Получение полиса - Страховой`,
            description: "",
            model_type: this.type,
            model_id: this.data.id,
          });

          return responseData;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },
  },
  props: ["value", "data", "currentRequest", "type"],
};
</script>
